import { useRef, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";



export default function Timer({onComplete}){
  const currentTime = useRef(0);
  const prevTime = useRef(null);
  const isNewTimeFirstTick = useRef(false);
  const [, setOneLastRerender] = useState(0);

  const renderTime = ({ remainingTime }) => {
    if (currentTime.current !== remainingTime) {
      isNewTimeFirstTick.current = true;
      setTimeout(() => {
        isNewTimeFirstTick.current = false;
      }, 20);
      prevTime.current = currentTime.current;
      currentTime.current = remainingTime;
    }
  
    // force one last re-render when the time is over to tirgger the last animation
    if (remainingTime === 0) {
      setTimeout(() => {
        setOneLastRerender(val => val + 1);
      }, 20);
    }
  
    const isTimeUp = isNewTimeFirstTick.current;

    return (
      <div className="time-wrapper">
        <div key={remainingTime} className={`time ${isTimeUp ? "up" : ""}`}>
          {remainingTime - 1}
        </div>
        {prevTime.current !== null && (
          <div
            key={prevTime.current}
            className={`time ${!isTimeUp ? "down" : ""}`}
          >
            {prevTime.current}
          </div>
        )}
      </div>
    );
  };  
  return (
    <div className="timer-wrapper">
      <CountdownCircleTimer
        isPlaying
        duration={4}
        colors={[["#4963FE", 0.33], ["#4963FE", 0.33], ["#4963FE"]]}
        onComplete={onComplete}
      >
        {renderTime}
      </CountdownCircleTimer>
    </div>
  )
}